// TemplateSelectStep.tsx — step 'template-select' del onboarding (legacy).
// Qué hace: grilla de templates globales con select/deselect all y confirmación.
// Qué exporta: TemplateSelectStep.
// Quién lo usa: CreateWorkspaceModal.

import { TemplateSummary } from '@agency-smm/shared';
import { Button } from '../../Button';
import { TemplateThumbnail } from '../TemplateThumbnail';
import { TplActions, SelectAllLink, TplGrid } from '../styled';

interface Props {
  globalTemplates: TemplateSummary[];
  selectedTemplates: Set<string>;
  setSelectedTemplates: React.Dispatch<React.SetStateAction<Set<string>>>;
  confirmTemplates: () => void;
}

export function TemplateSelectStep({
  globalTemplates, selectedTemplates, setSelectedTemplates, confirmTemplates,
}: Props) {
  return (
    <>
      <TplActions>
        <span style={{ color: '#64748B' }}>{selectedTemplates.size}/{globalTemplates.length} selected</span>
        <SelectAllLink onClick={() => {
          if (selectedTemplates.size === globalTemplates.length) {
            setSelectedTemplates(new Set());
          } else {
            setSelectedTemplates(new Set(globalTemplates.map(t => t.id)));
          }
        }}>
          {selectedTemplates.size === globalTemplates.length ? 'Deselect all' : 'Select all'}
        </SelectAllLink>
      </TplActions>
      <TplGrid>
        {globalTemplates.map(tpl => (
          <TemplateThumbnail
            key={tpl.id}
            templateId={tpl.id}
            selected={selectedTemplates.has(tpl.id)}
            onClick={() => {
              setSelectedTemplates(prev => {
                const next = new Set(prev);
                next.has(tpl.id) ? next.delete(tpl.id) : next.add(tpl.id);
                return next;
              });
            }}
          />
        ))}
      </TplGrid>
      <Button type="button" onClick={confirmTemplates} disabled={selectedTemplates.size === 0} style={{ width: '100%' }} $size="sm">
        {selectedTemplates.size === 0 ? 'Select at least 1 template' : `Continue with ${selectedTemplates.size} template${selectedTemplates.size !== 1 ? 's' : ''}`}
      </Button>
    </>
  );
}
